import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "@phosphor-icons/react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { GoogleRatingBadge } from "@/components/GoogleReviews";
import { PHONE_DISPLAY, PHONE_TEL } from "@/seoData";

export const CtaButtons = ({ prefix = "page" }) => (
  <div className="mt-7 flex flex-wrap items-center gap-3">
    <a href={`tel:${PHONE_TEL}`} data-testid={`${prefix}-call-button`} className="flex items-center gap-2 bg-[#46A01E] hover:bg-[#3A8418] text-white font-display font-extrabold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-colors">
      <Phone size={18} weight="fill" /> Call/Text {PHONE_DISPLAY}
    </a>
    <Link to="/book" data-testid={`${prefix}-book-button`} className="flex items-center gap-2 border border-white/50 text-white font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm hover:bg-white/10 transition-colors">
      <CalendarCheck size={18} weight="fill" /> Book Online
    </Link>
  </div>
);

export default function PageShell({ seo, eyebrow, h1, lead, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, [seo.canonical]);
  return (
    <div className="bg-white text-[#0A0A0A] overflow-x-hidden">
      <Seo {...seo} />
      <Header />
      <section className="px-5 lg:px-8 pt-28 sm:pt-44 lg:pt-52 pb-14 bg-[#0B1E45] text-white">
        <div className="max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-2 text-[#5DB82F] font-display font-bold uppercase tracking-widest text-xs mb-4">
            <span className="h-px w-8 bg-[#5DB82F]" /> {eyebrow}
          </div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.98]" data-testid="page-h1">{h1}</h1>
          <p data-speakable className="mt-5 text-lg text-white/80 max-w-2xl leading-relaxed">{lead}</p>
          <GoogleRatingBadge />
          <CtaButtons />
        </div>
      </section>
      {children}
      <Footer />
    </div>
  );
}
